module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('h2', [_vm._v("Audi Field Fanwalk")]), _vm._v(" "), _c('div', {
    staticClass: "font-lg"
  }, [_c('p', [_vm._v("\n                        As D.C. United prepare to move to Audi Field in 2018, United fans now have an exclusive opportunity to cement their names in the legacy of Major League Soccer’s most decorated club. The prominent Audi Field Fanwalk will run along Potomac Avenue leading up to the fan plaza and main entry gate and will be built with special bricks bearing the names of D.C. United’s most ardent supporters. These customizable bricks are the perfect gift for family, friends and colleagues and each Fanwalk brick will come with one replica brick for display in your home or office.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Orders received by November 19th will ship in time for delivery by December 25, 2017 for no additional charge. For rush delivery options, please call 1-844-891-9788.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Space is limited and bricks will be offered on a first come, first served basis. Order now and write your name in D.C. United history.\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "color-red"
  }, [_c('router-link', {
    attrs: {
      "to": "/shop"
    }
  }, [_c('strong', [_vm._v("Click here to order your brick today!")])])], 1)]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/shop"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "images/aboutbricks.png",
      "alt": ""
    }
  })])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc8967d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = kDjr
// module chunks = 1